module.exports = __webpack_public_path__ + "img/54-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO8.a04b40b9.jpg";